import { z } from 'zod';

/**
 * Where a person is, read off their last movement of the day — the People
 * list's "Now" (`/attendance/people-day`) and the registry's `now` filter.
 *
 * A LEAF MODULE ON PURPOSE: it imports nothing but zod. The filter registry
 * needs it, and `companyMovements.schema.ts` imports `attendance.schema.ts`,
 * which re-exports a schema that imports the registry — so the registry
 * reaching into `companyMovements.schema.ts` closed a module cycle that a
 * browser evaluates in the wrong order (`MAX_ATTENDANCE_RANGE_DAYS` read
 * before it was initialised, the whole app blank). Vitest's loader tolerated
 * it; Vite in the browser did not.
 *
 * NO "IN TRANSIT" (owner, 2026-11-03). A camp punch is work at the camp now,
 * and going to site is the dispatch's record, so no punch can say somebody is
 * on the way. The value is gone; an old `?now=inTransit` link fails this
 * schema and the registry reads it as absent.
 */
export const PersonNowSchema = z.enum(['onSite', 'left', 'atCamp', 'onBreak']);
export type PersonNow = z.infer<typeof PersonNowSchema>;
